var map = {
	"./bot-chat.png": "/JZz",
	"./broadcast-icon.png": "TY6r",
	"./chat/agent-icon.png": "kV3W",
	"./chat/background-chat.svg": "R2e5",
	"./chat/bot-icon.png": "1mto",
	"./chat/dialogflow-icon.png": "xw6p",
	"./chat/emoji-icon.png": "N7P3",
	"./chat/kdcagpt-interno.png": "zpL6",
	"./chat/kdcagpt-visible.png": "UjIF",
	"./chat/send-icon.png": "hko2",
	"./chat/template-icon.png": "krf1",
	"./decreasing-triangle-black.png": "2hQi",
	"./decreasing-triangle-white.png": "EnAl",
	"./growing-triangle-black.png": "20tb",
	"./growing-triangle-white.png": "nv3T",
	"./loading.gif": "G/2H",
	"./logo-dark.png": "ja13",
	"./logo-white.png": "wYO/",
	"./logo.png": "7Otq",
	"./logoKDCA-white.svg": "56GT",
	"./logoKDCA.svg": "DQy9",
	"./logoKDCAbox-white.svg": "pXbJ",
	"./logoKDCAbox.svg": "t18n",
	"./logoKRCA-white.svg": "DLP7",
	"./logoKRCA.svg": "q32Q",
	"./logoKRCAbox-white.svg": "Sknc",
	"./logoKRCAbox.svg": "SmdY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1